.bodyLg {
  font: var(--body-lg-font);
  letter-spacing: var(--body-lg-letter-spacing);
}

.bodyMd {
  font: var(--body-md-font);
  letter-spacing: var(--body-md-letter-spacing);
}

.bodySm {
  font: var(--body-sm-font);
  letter-spacing: var(--body-sm-letter-spacing);
}

.bodyLg.heavy,
.bodyLg strong,
.bodyLg b {
  font: var(--body-lg-heavy-font);
  letter-spacing: var(--body-lg-heavy-letter-spacing);
}

.bodyMd.heavy,
.bodyMd strong,
.bodyMd b {
  font: var(--body-md-heavy-font);
  letter-spacing: var(--body-md-heavy-letter-spacing);
}

.bodySm.heavy,
.bodySm strong,
.bodySm b {
  font: var(--body-sm-heavy-font);
  letter-spacing: var(--body-sm-heavy-letter-spacing);
}

.primary {
  color: var(--content-primary);
}

.secondary {
  color: var(--content-secondary);
}

.tertiary {
  color: var(--content-secondary);
}

.light {
  color: var(--content-inverse);
}

.disabled {
  color: var(--content-disabled);
}

.accent {
  color: var(--content-accent);
}

.success {
  color: var(--content-status-success);
}

.warning {
  color: var(--content-status-warning);
}

.danger {
  color: var(--content-status-error);
}

.plus {
  color: var(--brand-colors-plus-brand);
}

.left {
  text-align: left;
}

.center {
  text-align: center;
}

.right {
  text-align: right;
}
